import { mapActions, mapState } from 'vuex'
import listItemMatch from '@/components/list-item-match/list-item-match.vue'
import listItemTeam from '@/components/list-item-team/list-item-team.vue'
import listItemPlayer from '@/components/list-item-player/list-item-player.vue'
import { api } from '@/plugins/api'

export default {
  components: {
    listItemTeam,
    listItemPlayer,
    listItemMatch
  },
  data () {
    return {
      requestIsLoading: false,
      rules: {
        required: value => !!value || this.$t('error_required'),
        required40: value => (value || '').length > 40 || 'Min 40 characters'
      },
      cityGameForm: {
        name: '',
        team: ''
      }
    }
  },
  watch: {
    'user.cityGame': {
      handler: function (cityGame) {
        if (cityGame) {
          this.cityGameForm.name = cityGame.team
          this.cityGameForm.team = cityGame.order
        }
      },
      immediate: true,
      deep: true
    }
  },
  computed: {
    ...mapState(['user', 'teams', 'matches', 'content', 'players', 'superBadges']),
    team () {
      return this.teams[this.user.assignedTeam]
    },
    tournamentFinished () {
      return !this.matches.find(m => !m.hasFinished)
    },
    rankTeams () {
      return Object.values(this.teams).filter(t => t.finalRank)
        .sort((a, b) => {
          return a.finalRank - b.finalRank
        })
    },
    rankPlayers () {
      const rankBadges = this.superBadges.filter(b => b.finalRank === true).map(b => b.id)
      return Object.values(this.players).filter(p => {
        return !!(p.badges || []).find(b => rankBadges.includes(b))
      })
        .map(p => {
          p.finalBadge = (p.badges || []).find(b => rankBadges.includes(b))
          return p
        })
    },
    links () {
      return this.content
        ? [
            {
              icon: 'mdi-party-popper',
              link: { name: 'playerParty', params: { playerId: this.user ? this.user.id : '' } },
              title: 'Party pass'
            },
            {
              icon: 'mdi-map-legend',
              id: 'map-map',
              title: 'Mapa'
            },
            {
              icon: 'mdi-note-text-outline',
              id: 'rules-terms',
              title: 'Zasady'
            },
            {
              icon: 'mdi-tournament',
              id: 'rules-format',
              title: 'Turniej'
            },
            {
              icon: 'mdi-whatsapp',
              link: 'https://chat.whatsapp.com/L6HvWCkXZg9Bn0D0BAN7SM',
              title: 'Grupa WhatsApp',
              external: true,
              cols: 6
            },
            {
              icon: 'mdi-calendar',
              link: 'https://www.facebook.com/events/1053433595792913/?active_tab=discussion',
              title: 'Fb event',
              external: true,
              cols: 6
            }
          ]
        : []
    },
    nextMatch () {
      if (!this.team) return null
      return this.matches
        .find(m => !m.hasFinished && (m.team1 === this.team.id || m.team2 === this.team.id))
    },
    lastMatch () {
      const matches = this.matches
        .filter(m => m.hasFinished && (!this.team || m.team1 === this.team.id || m.team2 === this.team.id))
      if (!matches.length) return null

      return matches[matches.length - 1]
    },
    matchTime () {
      return this.nextMatch ? `${this.nextMatch.day === 2 ? 'Niedziela' : 'Sobota'}, ${this.nextMatch.timeStart}, boisko ${this.nextMatch.field}` : ''
    },
    team1 () {
      return this.nextMatch && this.nextMatch.team1 ? this.teams[this.nextMatch.team1] : null
    },
    team2 () {
      return this.nextMatch && this.nextMatch.team2 ? this.teams[this.nextMatch.team2] : null
    },
    badgesCount () {
      const badges = (this.user.badges || []).filter(b => b !== 'organizer').length
      return badges || 'Brak odznak'
    }
  },
  methods: {
    ...mapActions(['loadData']),
    cityGameRegister () {
      if (this.$refs.cityGameForm.validate()) {
        this.requestIsLoading = true
        return api.registerCityGame({ ...this.cityGameForm }).finally(() => {
          this.loadData().finally(() => { this.requestIsLoading = false })
        })
      }
    }
  }
}
